import React, { FC, memo, useCallback, useEffect } from 'react';
import FnRadioGroup from '../../../../components/elements/FnRadioGroup/index';
import { ColorgateConfigurationFields, RadioValues } from '../../constants';
import { TOption } from '../../types';

type TProps = {
  name: ColorgateConfigurationFields;
  options: TOption[];
  value: RadioValues;
  defaultSizeFieldValue: RadioValues;
  setFieldValue: (field: ColorgateConfigurationFields, value: string) => void;
  title?: string;
};

const ProportionalField: FC<TProps> = ({ name, options, value, defaultSizeFieldValue, setFieldValue, title = '' }) => {
  useEffect(() => {
    if (defaultSizeFieldValue === RadioValues.Yes) {
      setFieldValue(name, RadioValues.No);
    }
  }, [defaultSizeFieldValue]);

  const handleChange = useCallback(
    (optionValue: string) => {
      setFieldValue(name, optionValue);
    },
    [setFieldValue, name]
  );

  return (
    <FnRadioGroup
      propertyValue="value"
      propertyLabel="name"
      options={options}
      value={value}
      title={title}
      onChange={handleChange}
      name={name}
      disabled={defaultSizeFieldValue === RadioValues.Yes}
      hasInnerBlock
    />
  );
};

export default memo(ProportionalField);
